import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { ArrowLeft, Users, DollarSign, Video, ShoppingBag, BookOpen, Check, X, Upload, TrendingUp, Crown, Lock, Unlock, Settings, RefreshCw, Globe, Edit3, FileSpreadsheet, AlertCircle, Download, Youtube, Plus, Layers, Calendar, Flag, Star, Trash2, Gift, Ban, UserX, UserCheck, CheckCircle, ShieldCheck, Clock, PartyPopper, Archive } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Switch } from '../ui/switch';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../ui/alert-dialog';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Tier Features tab.
 *
 * Lifted out of AdminPanel.js during the Phase 2 frontend split (Wave 4).
 * Pure presentational — receives parent state + handlers via props.
 */
export default function TierFeaturesTab(props) {
  const { user, navigate, getAuthHeader, fetchAllData, fileInputRef, users, setUsers, userSearch, setUserSearch, filteredUsers, pendingFounders, founderSettings, setFounderSettings, founderSeatsRemaining, updateFounderSettings, toggleFounderEnrollment, toggleFoundingMember, suspendUser, archiveUser, permanentlyDeleteUser, changeUserTier, sales, pendingSales, pendingListingSales, handleVerifySale, handleVerifyListingSale, handleUnverifyListingSale, handleCancelListingSale, commissionDashboard, promoCodes, newPromo, setNewPromo, createPromoCode, deletePromoCode, promoToDelete, setPromoToDelete, potData, setPotData, updatePot, advertisers, pendingVideos, pendingLibraryVideos, handleBatchApproveVideos, handleVideoReview, handleLibraryVideoReview, moveDownlineData, setMoveDownlineData, featuredMembers, selectedUserToFeature, setSelectedUserToFeature, featuredText, setFeaturedText, handleAddFeaturedMember, handleRemoveFeaturedMember, tierFeatures, editingTier, setEditingTier, editFeatures, setEditFeatures, startEditingTier, saveTierFeatures, customTiers, showTierForm, setShowTierForm, newTier, setNewTier, tierFeaturesInput, setTierFeaturesInput, handleCreateTier, handleDeleteTier, pendingServices, flaggedServices, handleApproveService, handleFlagService, handleDeleteService, edirectoryStatus, syncingEdir, syncEdirectory, importedTransactions, importing, importResult, handleFileSelect, downloadSampleCSV } = props;

  return (
    <div className="space-y-4" data-testid="tiers-tab">
      <h2 className="text-2xl font-playfair font-bold text-foreground mb-4 flex items-center gap-2">
                    <Edit3 className="w-6 h-6 text-primary" /> Edit Membership Tier Features
                  </h2>
                  <p className="text-muted-foreground mb-6">
                    Customize the features displayed for each membership tier on the pricing page.
                  </p>
            
                  <div className="grid md:grid-cols-3 gap-6">
                    {['ascend', 'growth', 'founder'].map((tier) => (
                      <div key={tier} className={`wm-card p-6 rounded-lg border-2 ${
                        tier === 'founder' ? 'border-orange-500/30' : 
                        tier === 'growth' ? 'border-purple-500/30' : 'border-blue-500/30'
                      }`}>
                        <h3 className={`text-xl font-semibold capitalize mb-4 ${
                          tier === 'founder' ? 'text-orange-600' : 
                          tier === 'growth' ? 'text-purple-400' : 'text-blue-400'
                        }`}>{tier} Tier</h3>
                  
                        {editingTier === tier ? (
                          <div className="space-y-4">
                            <Textarea
                              value={editFeatures}
                              onChange={(e) => setEditFeatures(e.target.value)}
                              placeholder="One feature per line..."
                              rows={10}
                              className="bg-input border-border text-foreground text-sm"
                              data-testid={`edit-${tier}-features`}
                            />
                            <div className="flex gap-2">
                              <Button onClick={saveTierFeatures} className="bg-green-600 hover:bg-green-700" data-testid={`save-${tier}-features`}>
                                <Check className="w-4 h-4 mr-1" /> Save
                              </Button>
                              <Button onClick={() => setEditingTier(null)} variant="outline">
                                <X className="w-4 h-4 mr-1" /> Cancel
                              </Button>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <ul className="space-y-2 mb-4 max-h-64 overflow-y-auto">
                              {tierFeatures[tier]?.map((feature, idx) => (
                                <li key={idx} className="flex items-start gap-2 text-sm text-muted-foreground">
                                  <Check className={`w-4 h-4 mt-0.5 flex-shrink-0 ${
                                    tier === 'founder' ? 'text-orange-600' : 
                                    tier === 'growth' ? 'text-purple-500' : 'text-blue-500'
                                  }`} />
                                  {feature}
                                </li>
                              ))}
                            </ul>
                            <Button 
                              onClick={() => startEditingTier(tier)} 
                              variant="outline"
                              className="w-full"
                              data-testid={`edit-${tier}-btn`}
                            >
                              <Edit3 className="w-4 h-4 mr-2" /> Edit Features
                            </Button>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
    </div>
  );
}
